import { render, staticRenderFns } from "./NavTab.vue?vue&type=template&id=7ec505d6&"
import script from "./NavTab.vue?vue&type=script&lang=js&"
export * from "./NavTab.vue?vue&type=script&lang=js&"
import style0 from "./NavTab.vue?vue&type=style&index=0&id=7ec505d6&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports